module.exports = __webpack_public_path__ + "static/media/auth-phone.8985f615.jpg";